/**
 * Class to handle the dropdownMenu element (used on the sidebar buttons)
 * Listen to click on toggle and open / close menu.
 * When menu is open, listen to click outside of menu to close menu
 */
class DropdownMenu {
  constructor(containerEl, linksEl, toggleEl) {
    this.container = containerEl;
    this.links = linksEl;
    this.toggle = toggleEl;
    this.isOpen = false;
    this._state = false;
    this._handleClickWhenMenuOpen = this._handleClickWhenMenuOpen.bind(this);

    this.toggle.addEventListener('click', () => {
      this._state = !this.isOpen;
      this.toggle.blur();
    });
  }

  /**
   * Open / close the menu and add according aria attributes according to the state
   *
   * @param value
   * @private
   */
  set _state(value) {
    this.isOpen = value;

    if (this.isOpen) {
      this.container.setAttribute('isOpen', '');
      this.container.setAttribute('aria-expanded', true);
      this.container.setAttribute('aria-activedescendant', this.links.id);
      window.addEventListener('click', this._handleClickWhenMenuOpen);
    } else {
      this.container.removeAttribute('isOpen');
      this.container.setAttribute('aria-expanded', false);
      this.container.removeAttribute('aria-activedescendant');
      window.removeEventListener('click', this._handleClickWhenMenuOpen);
    }
  }

  /**
   * If click is outside of the menu, close the menu
   *
   * @param event
   * @private
   */
  _handleClickWhenMenuOpen(event) {
    if (!event.target.closest(`#${this.container.getAttribute('id')}`)) {
      this._state = false;
    }
  }
}

/**
 * Wait for the page to load
 * Get necessary elements and create an instance of the dropdownMenu class
 */
document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.d1i-dropdown-menu');

  if (!dropdowns) return;

  dropdowns.forEach((dropdown) => {
    const dropdownLinks = dropdown.querySelector('.d1i-dropdown-menu__links');
    const dropdownToggle = dropdown.querySelector('.d1i-dropdown-menu__toggle');

    if (!dropdown || !dropdownLinks || !dropdownToggle) {
      console.error('TOUJOU: Could not initialize the "Anreise planen" dropdown menu');
      return;
    }

    dropdown._dropdown = new DropdownMenu(dropdown, dropdownLinks, dropdownToggle);
  });
});
